// src/components/player-profile/PlayerNotesTab.js
//
// Extracted from inline module-level definition in PlayerProfileModal.js
// per IMPORTANT batch 8 commit 8f. Pure presentational — zero parent
// closure refs, props-only (notes, player); no §14.test-infra.4 trivial
// helper sub-pattern needed.
//
// Three quality/a11y fixes folded in during extraction (same render
// path, single coherent surface):
//   - 📰 emoji: role="img" + aria-label="News" so screen readers
//     announce a meaningful label.
//   - INJURY badge: aria-label="Injury report" (color-only red→text was
//     the a11y gap).
//   - NEWS badge: aria-label="News update" (color-only blue→text was
//     the a11y gap).
//
// `key={index}` retained on the .map: backend `/api/mlb/news/player-notes`
// (mlb.py:485) projects {player_id, player_name, note_type, content,
// source, date} with no stable per-note id. Backend data shape gap
// surfaced in 8f apply report; not invented here per dispatch policy
// against synthetic content-composite keys.
import React from 'react';
import { dynastyTheme } from '../../services/colorService';

const PlayerNotesTab = ({ notes, player }) => {
  if (!notes || notes.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <span className="text-4xl mb-3" role="img" aria-label="News">📰</span>
        <p className={`${dynastyTheme.classes.text.neutralLight} text-sm`}>
          No recent news for {player?.info?.first_name} {player?.info?.last_name}
        </p>
      </div>
    );
  }

  return (
    <div className="p-4 space-y-3 max-h-96 overflow-y-auto">
      {notes.map((note, index) => {
        const isInjury = note.note_type === 'injury';
        return (
          <div
            key={index}
            className="p-3 rounded-lg bg-neutral-800 border border-neutral-700"
          >
            <div className="flex items-center justify-between mb-2">
              <span
                aria-label={isInjury ? 'Injury report' : 'News update'}
                className={`text-xs font-bold px-2 py-0.5 rounded ${
                  isInjury
                    ? 'bg-red-500/20 text-red-400 border border-red-500/30'
                    : 'bg-blue-500/20 text-blue-400 border border-blue-500/30'
                }`}
              >
                {isInjury ? 'INJURY' : 'NEWS'}
              </span>
              <span className={`text-xs ${dynastyTheme.classes.text.neutralLight}`}>
                {note.date ? new Date(note.date).toLocaleDateString() : ''}
              </span>
            </div>
            <p className={`text-sm ${dynastyTheme.classes.text.white} leading-relaxed`}>
              {note.content}
            </p>
            <p className={`text-xs ${dynastyTheme.classes.text.neutralLight} mt-1`}>
              {note.source}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default PlayerNotesTab;
